import React, { useContext } from "react";
import { DeviceSection } from "../../context/DeviceContext";
import { useTranslation } from "react-i18next";
const DeviceFirstPage = () => {
  const { ShowHideDeviceFunction } = useContext(DeviceSection);
  const { t } = useTranslation();
  return (
    <>
      <div className="d-flex justify-content-around align-items-center">
        <div className="addScenarioCard bg-white p-3">
          <div className="text-right">
            <p className="fn">{t("اضافه کردن دستگاه")}</p>
            <p className="m-0 fn12">
              {t("شما میتوانید دستگاه دلخواه خود را اضافه کنید")}
            </p>
          </div>
        </div>
        <div
          className="addScenarioIcon d-flex m-2 justify-content-center align-items-center rounded-circle text-white cursor"
          onClick={() => ShowHideDeviceFunction("scanDevice")}
        >
          +
        </div>
      </div>
    </>
  );
};

export { DeviceFirstPage };
